import auth0 from 'auth0-js';
import invariant from 'tiny-invariant';

import { isFirebasePreview } from './utils';

const webAuthInstance: auth0.WebAuth | null = null;

interface GetWebAuthType {
  appRedirect?: boolean;
  invitedEmail?: string;
}

export const getWebAuth = ({ appRedirect, invitedEmail }: GetWebAuthType) => {
  if (!webAuthInstance) {
    try {
      const baseRedirectUri = isFirebasePreview(location.origin)
        ? location.origin
        : globalThis.ENV.AUTH0_REDIRECT_URI || location.origin;
      const callbackPath = appRedirect
        ? '/app/auth-app/callback'
        : invitedEmail
          ? `/app/authorize/callback?invited_email=${encodeURIComponent(invitedEmail)}`
          : '/app/authorize/callback';
      const redirectUri = `${baseRedirectUri}${callbackPath}`;

      invariant(globalThis.ENV.AUTH0_DOMAIN, 'AUTH0_DOMAIN is not defined');
      invariant(globalThis.ENV.AUTH0_CLIENT_ID, 'AUTH0_CLIENT_ID is not defined');

      const params = {
        overrides: { __tenant: globalThis.ENV.AUTH0_TENANT },
        domain: globalThis.ENV.AUTH0_DOMAIN,
        clientID: globalThis.ENV.AUTH0_CLIENT_ID,
        redirectUri,
        audience: globalThis.ENV.AUTH0_AUDIENCE,
        responseType: 'code',
        universalLoginPage: false,
      };
      return new auth0.WebAuth(params);
    } catch {
      return null;
    }
  }

  return webAuthInstance;
};
